import React, { Suspense, lazy, useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import 'animate.css/animate.min.css';
import { WOW } from 'wowjs';

import Preloader from '../components/Preloader';
import ScrollToTop from '../components/ScrollToTop';
import LoadTop from '../components/ScrollToTop/LoadTop';
import { SiteSettingsProvider } from '../lib/api/settings';
import { RouteSeo } from '../lib/seo';
import PreviewGate from '../components/PreviewGate';
import { Album, Gallery } from '../pages/gallery';
import { ProjectDetails, Projects } from '../pages/projects';

import {
  About,
  Blog,
  BlogDetails,
  BlogSidebar,
  Contact,
  CourseDetails,
  CourseOne,
  Error,
  Event,
  EventDetails,
  Faq,
  HomeThree,
  InstructorRegistration,
  Leadership,
  Service,
  ServiceDetails,
  ServiceThree,
  ServiceTwo,
  Teacher,
  TeacherDetails,
  Testimonial,
} from '../pages';

// The back office is loaded only when someone opens /admin, so the public site does not carry its code.
const AdminApp = lazy(() => import('../admin/AdminApp'));

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  //preloader
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 500);
  }, []);

  //Initialize wow
  useEffect(() => {
    new WOW({ live: false, animateClass: 'animate__animated' }).init();
  }, [location]);

  return (
    <SiteSettingsProvider>
    <PreviewGate>
    <div className="App">
      {isLoading && !location.pathname.startsWith('/admin') && <Preloader />}
      <RouteSeo />
      <ScrollToTop />
      <LoadTop />
      <Routes>
        <Route path="/" element={<HomeThree />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/programs" element={<CourseOne />} />
        <Route path="/programs/:slug" element={<CourseDetails />} />
        <Route path="/program-types" element={<Service />} />
        <Route path="/why-sanasa" element={<ServiceTwo />} />
        <Route path="/facilities" element={<ServiceThree />} />
        <Route path="/research" element={<ServiceDetails />} />
        <Route path="/events" element={<Event />} />
        <Route path="/events/:slug" element={<EventDetails />} />
        <Route path="/staff" element={<Teacher />} />
        <Route path="/leadership" element={<Leadership />} />
        <Route path="/chairman" element={<TeacherDetails />} />
        <Route path="/apply" element={<InstructorRegistration />} />
        <Route path="/student-voices" element={<Testimonial />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/news" element={<Blog />} />
        <Route path="/news/:slug" element={<BlogDetails />} />
        <Route path="/news-archive" element={<BlogSidebar />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:slug" element={<ProjectDetails />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/gallery/:slug" element={<Album />} />
        <Route
          path="/admin/*"
          element={
            <Suspense fallback={null}>
              <AdminApp />
            </Suspense>
          }
        />

        {/* Old template addresses still resolve: they redirect to the new ones */}
        <Route path="/course-1" element={<Navigate to="/programs" replace />} />
        <Route path="/course-details" element={<Navigate to="/programs/bsc-banking-finance" replace />} />
        <Route path="/event" element={<Navigate to="/events" replace />} />
        <Route path="/event-details" element={<Navigate to="/events/convocation-2020" replace />} />
        <Route path="/teacher" element={<Navigate to="/staff" replace />} />
        <Route path="/teacher-details" element={<Navigate to="/chairman" replace />} />
        <Route path="/instructor-registration" element={<Navigate to="/apply" replace />} />
        <Route path="/services-1" element={<Navigate to="/program-types" replace />} />
        <Route path="/services-2" element={<Navigate to="/why-sanasa" replace />} />
        <Route path="/services-3" element={<Navigate to="/facilities" replace />} />
        <Route path="/service-details" element={<Navigate to="/research" replace />} />
        <Route path="/testimonial" element={<Navigate to="/student-voices" replace />} />
        <Route path="/blog-1" element={<Navigate to="/news" replace />} />
        <Route path="/blog-details" element={<Navigate to="/news/landslide-survey-2023" replace />} />

        <Route path="/course-2" element={<Navigate to="/programs" replace />} />
        <Route path="/student-registration" element={<Navigate to="/apply" replace />} />
        <Route path="/blog-2" element={<Navigate to="/news" replace />} />
        <Route path="*" element={<Error />} />
      </Routes>
    </div>
    </PreviewGate>
    </SiteSettingsProvider>
  );
}

export default App;
